// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getProductListDataView } from "@insite/client-framework/Store/Pages/ProductList/ProductListSelectors";
import translate from "@insite/client-framework/Translate";
import { SuggestionModel } from "@insite/client-framework/Types/ApiModels";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Link from "@insite/mobius/Link";
import Typography from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React from "react";
import { connect } from "react-redux";

/* Starter Custom Code - Start */
import getContentSearchUrl from "@store/Framework/Common/Utilities/getContentSearchUrl";
import { getContentSearchCurrentTab } from "@store/Framework/Store/Starter/Pages/ProductList/ProductListSelectors";
/* Starter Custom Code - End */

const mapStateToProps = (state: ApplicationState) => {
    const productsDataView = getProductListDataView(state);
    const { extensionContentSearchSettings } = getSettingsCollection(state); // Starter Custom Code
    if (productsDataView.value) {
        return {
            loaded: true,
            searchPath: getSettingsCollection(state).searchSettings.searchPath,
            didYouMeanSuggestions: productsDataView.didYouMeanSuggestions,
            correctedQuery: productsDataView.correctedQuery,
            originalQuery: productsDataView.originalQuery,
            // Starter Custom Code
            enableContentSearchResults:
                extensionContentSearchSettings && extensionContentSearchSettings.enableContentSearchResults,
            contentSearchCurrentTab: getContentSearchCurrentTab(state),
        };
    }
    return {
        loaded: false,
        searchPath: "",
        didYouMeanSuggestions: [] as SuggestionModel[],
        correctedQuery: "",
        originalQuery: "",
        // Starter Custom Code
        enableContentSearchResults:
            extensionContentSearchSettings && extensionContentSearchSettings.enableContentSearchResults,
        contentSearchCurrentTab: getContentSearchCurrentTab(state),
    };
};

type Props = WidgetProps & ReturnType<typeof mapStateToProps>;

export interface ProductListSuggestionStyles {
    wrapper?: InjectableCss;
}

export const suggestionStyles: ProductListSuggestionStyles = {};

const styles = suggestionStyles;

const ProductListSuggestion = ({
    loaded,
    searchPath,
    didYouMeanSuggestions,
    originalQuery,
    correctedQuery,
    // Starter Custom Code
    contentSearchCurrentTab,
    enableContentSearchResults,
}: Props) => {
    /* Starter Custom Code - Start */
    const hasDidYouMean = didYouMeanSuggestions && didYouMeanSuggestions.length > 0;
    const hasCorrectedQuery = correctedQuery && originalQuery !== correctedQuery;
    const contentSearchPrefixUrlDidYouMean = hasDidYouMean
        ? getContentSearchUrl(didYouMeanSuggestions[0].suggestion, searchPath, contentSearchCurrentTab)
        : undefined;
    const contentSearchPrefixUrlSearchInstead = hasCorrectedQuery
        ? getContentSearchUrl(originalQuery, searchPath, contentSearchCurrentTab)
        : undefined;
    const didYouMeanUrl = hasDidYouMean
        ? enableContentSearchResults
            ? contentSearchPrefixUrlDidYouMean
            : `/${searchPath}?query=${didYouMeanSuggestions[0].suggestion}`
        : undefined;
    const searchInsteadUrl = hasCorrectedQuery
        ? enableContentSearchResults
            ? `${contentSearchPrefixUrlSearchInstead}&includeSuggestions=false`
            : `/${searchPath}?query=${originalQuery}&includeSuggestions=false`
        : undefined;
    /* Starter Custom Code - End */

    if (!loaded && !hasDidYouMean && !hasCorrectedQuery /* Starter Custom Code */) {
        return null;
    }
    return (
        <StyledWrapper {...styles.wrapper}>
            {hasDidYouMean && didYouMeanSuggestions /* Starter Custom Code */ && (
                <>
                    <Typography>{translate("Did you mean ")}</Typography>
                    <Link
                        href={didYouMeanUrl} // Starter Custom Code
                    >
                        {didYouMeanSuggestions[0].suggestion}
                    </Link>
                </>
            )}
            {hasCorrectedQuery /* Starter Custom Code */ && (
                <>
                    <Typography>{translate("Search instead for ")}</Typography>
                    <Link
                        href={searchInsteadUrl} // Starter Custom Code
                        data-test-selector="productListOriginalQuery"
                    >
                        {originalQuery}
                    </Link>
                </>
            )}
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(ProductListSuggestion),
    definition: {
        group: "Product List",
        displayName: "Suggestion",
        allowedContexts: ["ProductListPage"],
    },
};

export default widgetModule;
